// extracted by mini-css-extract-plugin
module.exports = {"starsRewards":"_dffb6e5","optIn":"_4b8f578"};